export default () =>{
    const counters = document.querySelectorAll('[data-counter]');
   
    counters.forEach(el => {
        const num = el.querySelector('.first-num')
        const grid = document.querySelector('[data-collection-grid]');

        const images = grid.querySelectorAll('img');

        window.addEventListener('scroll', ()=>{
            images.forEach((image, index) =>{
                if (image.getBoundingClientRect().top < window.innerHeight/2 && image.getBoundingClientRect().bottom > window.innerHeight/2){
                    num.innerHTML = index + 1 
                }
            })
        })
    })
}